import { BankOperationCommentsSkeleton } from 'pages/Finance/BankOperations/components/BankOperationCommentsSkeleton';
import { useBankOperationComments } from 'pages/Finance/BankOperations/hooks/useBankOperationComments';
import { RequestsBankOpsShowComment } from 'pages/Finance/RequestsBankOps/RequestsBankOpsShow/RequestsBankOpsShowComment/RequestsBankOpsShowComment';
import { RecordContextProvider } from 'react-admin';
import { CancelButton } from 'shared/mui/Buttons';
import { Card, CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { BankOperation } from 'types/embedded/bankOperation';

type Props = DialogProps & {
  record: BankOperation | undefined;
};

export const RequestsBankOpsListCommentDialog: React.FC<Props> = ({ record, ...restProps }) => {
  const { comments, isLoading } = useBankOperationComments(record?.originId, restProps.open);

  return (
    <Dialog {...restProps} width="640px">
      <Card>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={restProps.onClose} />]}
          sx={{ height: 'auto' }}
          title="Комментарий при изменении статуса"
          titleSize="smallBold"
        />
        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {isLoading ? (
            <BankOperationCommentsSkeleton />
          ) : (
            comments.map((comment) => (
              <RecordContextProvider key={comment.id} value={comment}>
                <RequestsBankOpsShowComment />
              </RecordContextProvider>
            ))
          )}
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton
              key="close-button"
              label="Закрыть"
              onClick={restProps.onClose}
              variant="outlined"
            />,
          ]}
        />
      </Card>
    </Dialog>
  );
};
